import { render, staticRenderFns } from "./RecruitingIcon.vue?vue&type=template&id=0461dd7c"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0461dd7c')) {
      api.createRecord('0461dd7c', component.options)
    } else {
      api.reload('0461dd7c', component.options)
    }
    module.hot.accept("./RecruitingIcon.vue?vue&type=template&id=0461dd7c", function () {
      api.rerender('0461dd7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/RecruitingIcon.vue"
export default component.exports